export const BUILDING_IMAGE = 'https://lh3.googleusercontent.com/d/108_Q1HYplVCbxLFjIeGMdW6_y9dbEKfJ=w2000'
export const IMAGE_SIZE = { width: 2000, height: 1334 }

export const statusMeta = {
  available: { label: 'Beschikbaar', shortLabel: 'Vrij' },
  option: { label: 'Onder optie', shortLabel: 'Optie' },
  sold: { label: 'Verkocht', shortLabel: 'Verkocht' },
}

export const typeMeta = {
  A: { name: 'Smart', area: 42, rooms: 2, bedrooms: 1, price: 299000, energy: 'A+++' },
  B: { name: 'Comfort', area: 49, rooms: 2, bedrooms: 1, price: 345000, energy: 'A+++' },
  C: { name: 'Suite', area: 59, rooms: 3, bedrooms: 2, price: 399000, energy: 'A++(+)' },
  D: { name: 'Premium', area: 74, rooms: 3, bedrooms: 2, price: 490000, energy: 'A++(+)' },
}

const geometry = [
  { label:'sample-01', points:'605,536 697,510 701,605 608,625' },
  { label:'sample-02', points:'697,510 842,456 843,573 827,578 701,605' },
  { label:'sample-03', points:'842,456 929,427 978,407 1033,409 1035,551 971,552 930,553 843,573' },
  { label:'sample-04', points:'1033,409 1161,457 1164,582 1035,551' },
  { label:'sample-05', points:'1161,457 1249,491 1250,611 1164,582' },
  { label:'sample-06', points:'1249,491 1328,520 1329,636 1250,611' },
  { label:'sample-07', points:'608,625 701,605 705,709 607,728' },
  { label:'sample-08', points:'701,605 827,578 827,682 705,709' },
  { label:'sample-09', points:'827,578 843,573 930,553 971,552 970,663 936,663 827,682' },
  { label:'sample-10', points:'971,552 1035,551 1164,582 1168,687 1045,663 970,663' },
  { label:'sample-11', points:'1164,582 1250,611 1254,706 1168,687' },
  { label:'sample-12', points:'1250,611 1329,636 1331,725 1254,706' },
  { label:'sample-13', points:'607,728 705,709 708,794 606,802' },
  { label:'sample-14', points:'705,709 827,682 828,788 708,794' },
  { label:'sample-15', points:'827,682 936,663 970,663 970,778 828,788' },
  { label:'sample-16', points:'970,663 1045,663 1168,687 1168,790 1047,778 970,778' },
  { label:'sample-17', points:'1168,687 1254,706 1252,807 1168,790' },
  { label:'sample-18', points:'1254,706 1331,725 1335,817 1252,807' },
]

const statusPattern = [
  'available', 'option', 'available', 'sold', 'available', 'option',
  'sold', 'available', 'available', 'option', 'sold', 'available',
  'available', 'sold', 'option', 'available', 'available', 'sold',
]
const typePattern = ['A', 'B', 'C', 'D', 'B', 'A']
const orientations = ['Zuidwest', 'Zuid', 'West', 'Noordwest', 'Noord', 'Oost']

export const units = geometry.map((zone, index) => {
  const row = Math.floor(index / 6)
  const position = index % 6
  const floor = 3 - row
  const type = typePattern[position]
  const meta = typeMeta[type]
  const area = Number((meta.area + (floor - 2) * .8 + (position % 2) * 1.4).toFixed(1))
  const price = meta.price + (floor - 1) * 9000 + position * 2500

  return {
    id: `mees-${String(index + 1).padStart(2, '0')}`,
    zoneLabel: zone.label,
    number: `${floor}.${String(position + 1).padStart(2, '0')}`,
    floor,
    position,
    type,
    typeName: `Type ${type} — ${meta.name}`,
    status: statusPattern[index],
    price,
    area,
    rooms: meta.rooms,
    bedrooms: meta.bedrooms,
    energy: meta.energy,
    orientation: orientations[position],
    points: zone.points,
    isPlaceholder: true,
  }
})

export const floors = [...new Set(units.map((unit) => unit.floor))].sort((a, b) => b - a)
export const types = Object.keys(typeMeta)

export function unitDescription(unit) {
  return `${unit.typeName} is een lichte hoekwoning van circa ${Math.round(unit.area)} m² met ${unit.rooms} kamers. De woning ligt op de ${unit.floor}e verdieping, kijkt uit richting ${unit.orientation.toLowerCase()} en wordt turnkey opgeleverd met vloerverwarming, keuken en badkamer.`
}
